import ACTIONS from "../actions/actionTypes"

export const locale = (state = "en", action) => {
  if (action.type === ACTIONS.SET_LOCALE) return action.payload
  return state
}
